import { RCAlertBox } from '@reverbdotcom/cadence/components';
import React from 'react';
import { core_apimessages_Error as Error } from '../../schemas/rql';
import { CheckoutErrorList } from './CheckoutErrorList';

interface Props {
  errors: Error[];
}

export function CheckoutErrorAlertBox({ errors }: Props) {
  return (
    <RCAlertBox type="error">
      <CheckoutErrorList errors={errors} />
    </RCAlertBox>
  );
}
